import { api } from '@/common/http/axios';
import type { CustomParameterDefinitions } from '@/utils/jobCustomParameters';
import type { SystemConfigSource, TaskType } from './simulation';

export interface JobCustomParametersConfig {
  currentValue: string;
  defaultValue: string;
  source: SystemConfigSource;
}

export async function getJobCustomParameters(): Promise<CustomParameterDefinitions> {
  // 可选参数目录由组件局部处理失败，不能在打开创建窗口时弹全局错误。
  const response = await api.get('/job/custom-parameters', { _skipErrorHandler: true } as any);
  return response.data.data;
}

/** 「适用任务类型」下拉：全部未删除任务类型（含已停用，enableFlag=0）。 */
export async function getJobCustomParameterTaskTypes(): Promise<TaskType[]> {
  const response = await api.get('/system-config/job-custom-parameters/task-types');
  return response.data.data || [];
}

export async function getJobCustomParametersConfig(): Promise<JobCustomParametersConfig> {
  const response = await api.get('/system-config/job-custom-parameters');
  return response.data.data;
}

export async function updateJobCustomParametersConfig(parameters: string): Promise<JobCustomParametersConfig> {
  const response = await api.put('/system-config/job-custom-parameters', { parameters });
  return response.data.data;
}

export async function resetJobCustomParametersConfig(): Promise<JobCustomParametersConfig> {
  const response = await api.post('/system-config/job-custom-parameters/reset');
  return response.data.data;
}
